// extracted by mini-css-extract-plugin
export default {"root":"CopyActivityModal_root__wECge","container":"CopyActivityModal_container__Xd7Nm"};